import { Vault } from 'nftx.js';
import { useNftx, useTransaction } from '@nftx/react';
import { useSlippagePercentage } from '@/presentation/context/settings';
import { V2Position, V2Vault } from '@/core/migrate';
import migrateXToken from '@/infrastructure/migrate/migrateXToken';
import useInvalidateVault from './useInvalidateVault';

const useMigrateXToken = () => {
  const { network, provider, signer } = useNftx();
  const slippage = useSlippagePercentage();
  const invalidateVault = useInvalidateVault();

  return useTransaction(
    ({
      v2Vault,
      v3Vault,
      position,
    }: {
      v2Vault: V2Vault;
      v3Vault: Vault;
      position: V2Position;
    }) => {
      return migrateXToken({
        network,
        position,
        provider,
        signer,
        slippage,
        v2Vault,
        v3Vault,
      });
    },
    {
      onSuccess: async (_, { v2Vault: { vaultId } }) => {
        await invalidateVault(vaultId);
      },
    }
  );
};

export default useMigrateXToken;
